import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { ArrowLeft } from "lucide-react";

const fmt = (iso) => iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/New_York" }) + " ET" : "—";

export default function AdminProgress() {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    api.get("/admin/engagement/progress")
      .then(({ data }) => setRows(data.submissions || []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <Layout>
      <section className="container-summit py-10">
        <Link to="/admin" className="text-xs uppercase tracking-[0.18em] text-zinc-500 inline-flex items-center gap-2 hover:text-black"><ArrowLeft size={14} /> Admin</Link>
        <h1 className="serif text-3xl md:text-4xl mt-4">Share Your Progress — Submissions</h1>
        <p className="mt-2 text-sm text-zinc-500">Private participant follow-up updates. Visible only to program administrators.</p>

        <div className="card-flat mt-8 overflow-x-auto" data-testid="progress-submissions">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-[0.14em] text-zinc-500 border-b border-zinc-200">
                <th className="px-4 py-3">Submitted</th>
                <th className="px-4 py-3">Organization</th>
                <th className="px-4 py-3">Follow-Up Status</th>
                <th className="px-4 py-3">Opportunity Stage</th>
                <th className="px-4 py-3">Introduction / Support</th>
                <th className="px-4 py-3">Submitter</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-zinc-100 align-top" data-testid={`progress-row-${r.id}`}>
                  <td className="px-4 py-3 whitespace-nowrap text-zinc-500">{fmt(r.created_at)}</td>
                  <td className="px-4 py-3 font-medium">{r.organization}</td>
                  <td className="px-4 py-3">{r.follow_up_status}</td>
                  <td className="px-4 py-3">{r.opportunity_stage}</td>
                  <td className="px-4 py-3 max-w-[320px]">{r.introduction_support || "—"}</td>
                  <td className="px-4 py-3 text-zinc-500">{r.submitter_email || "—"}</td>
                </tr>
              ))}
              {loaded && rows.length === 0 && (
                <tr><td colSpan={6} className="px-4 py-10 text-center text-zinc-400">No submissions yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </Layout>
  );
}
